/**
 * @flow
 * @relayHash 68fec04b24f5252409cc643397eb452d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MergeTagsInput = {|
  ids: $ReadOnlyArray<?string>,
  name: string,
  mergeIfExists?: ?boolean,
  clientMutationId?: ?string,
|};
export type MergeTagsMutationVariables = {|
  input: MergeTagsInput
|};
export type MergeTagsMutationResponse = {|
  +mergeTags: ?{|
    +newTag: ?{|
      +id: string,
      +name: string,
    |},
    +nameExists: ?boolean,
  |}
|};
export type MergeTagsMutation = {|
  variables: MergeTagsMutationVariables,
  response: MergeTagsMutationResponse,
|};
*/


/*
mutation MergeTagsMutation(
  $input: MergeTagsInput!
) {
  mergeTags(input: $input) {
    newTag {
      id
      name
    }
    nameExists
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "MergeTagsInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "mergeTags",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MergeTagsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "newTag",
        "storageKey": null,
        "args": null,
        "concreteType": "TagNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "nameExists",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MergeTagsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "MergeTagsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "MergeTagsMutation",
    "id": null,
    "text": "mutation MergeTagsMutation(\n  $input: MergeTagsInput!\n) {\n  mergeTags(input: $input) {\n    newTag {\n      id\n      name\n    }\n    nameExists\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '71339e303bf79c1ce2fcae140e27a72d';
module.exports = node;
